import { OverlayContainer } from '@angular/cdk/overlay';
import { DecimalPipe, Location } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, enableProdMode, ErrorHandler, importProvidersFrom, LOCALE_ID, Type } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatSidenavModule } from '@angular/material/sidenav';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { CommonErrorInterceptor } from '@app/api/core/auth/interceptor/common.error.interceptor';
import { MatPaginatorIntlGerman } from '@app/api/core/utils/MatPaginatorIntlGerman';
import { AppComponent } from '@app/app.component';
import { MATERIAL_APP_ROUTES } from '@app/routes';
import { DATESTRING_DATE_FORMATS } from '@app/shared/components/form/basic-datepicker/datestring.adapter';
import { GlobalErrorHandler } from '@app/shared/error-handler/GlobalErrorHandler';
import { CustomDynamicFormService } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/custom-dynamic-form.service';
import { AbschlussComponent } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/abschluss/abschluss.component';
import { TYPE_ABSCHLUSS } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/abschluss/abschluss.model';
import { ActionButtonComponent } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/action-button/action-button.component';
import { TYPE_ACTION_BUTTON } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/action-button/action-button.model';
import { ChecklisteComponent } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/checkliste/checkliste.component';
import { TYPE_CHECKLISTE } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/checkliste/checkliste.model';
import { ChipChoiceAutocompleteComponent } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/chip-choice-autocomplete/chip-choice-autocomplete.component';
import { TYPE_CHIP_CHOICE_AUTOCOMPLETE } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/chip-choice-autocomplete/chip-choice-autocomplete.model';
import { ChipChoiceMultipleComponent } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/chip-choice-multiple/chip-choice-multiple.component';
import { TYPE_CHIP_CHOICE_MULTIPLE } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/chip-choice-multiple/chip-choice-multiple.model';
import { CollisionPickerComponent } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/collision-picker/collision-picker.component';
import { TYPE_COLLISION_PICKER } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/collision-picker/collision-picker.model';
import { CustomFileUploadComponent } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/custom-file-upload/custom-file-upload.component';
import { TYPE_CUSTOM_FILE_UPLOAD } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/custom-file-upload/custom-file-upload.model';
import { DataArrayComponent } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/data-array/data-array.component';
import { TYPE_DATA_ARRAY } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/data-array/data-array.model';
import { DateRangePickerComponent } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/date-range-picker/date-range-picker.component';
import { TYPE_DATE_RANGE_PICKER } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/date-range-picker/date-range-picker.model';
import { DokumentenAngabeComponent } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/dokumenten-angabe/dokumenten-angabe.component';
import { TYPE_DOKUMENTEN_ANGABE } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/dokumenten-angabe/dokumenten-angabe.model';
import { EigenleistungTableComponent } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/eigenleistung-table/eigenleistung-table.component';
import { TYPE_EIGENLEISTUNG_TABLE } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/eigenleistung-table/eigenleistung-table.model';
import { FahrradListeComponent } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/fahrrad-liste/fahrrad-liste.component';
import { TYPE_FAHRRAD_LISTE } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/fahrrad-liste/fahrrad-liste.model';
import { GebaeudeSchadenComponent } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/gebaeude-schaden/gebaeude-schaden.component';
import { TYPE_GEBAEUDE_SCHADEN } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/gebaeude-schaden/gebaeude-schaden.model';
import { GeschaedigteGeraeteEinfachComponent } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/geschaedigte-geraete-einfach/geschaedigte-geraete-einfach.component';
import { TYPE_GESCHAEDIGTE_GERAETE_EINFACH } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/geschaedigte-geraete-einfach/geschaedigte-geraete-einfach.model';
import { GeschaedigteGeraeteKomplexComponent } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/geschaedigte-geraete-komplex/geschaedigte-geraete-komplex.component';
import { TYPE_GESCHAEDIGTE_GERAETE_KOMPLEX } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/geschaedigte-geraete-komplex/geschaedigte-geraete-komplex.model';
import { GeschaedigtesFahrzeugComponent } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/geschaedigtes-fahrzeug/geschaedigtes-fahrzeug.component';
import { TYPE_GESCHAEDIGTES_FAHRZEUG } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/geschaedigtes-fahrzeug/geschaedigtes-fahrzeug.model';
import { HaftpflichtForderungAufstellungComponent } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/haftpflicht-forderung-aufstellung/haftpflicht-forderung-aufstellung.component';
import { TYPE_HAFTPFLICHT_FORDERUNG_AUFSTELLUNG } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/haftpflicht-forderung-aufstellung/haftpflicht-forderung-aufstellung.model';
import { HaftpflichtGeschaedigtePersonComponent } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/haftpflicht-geschaedigte-person/haftpflicht-geschaedigte-person.component';
import { TYPE_HAFTPFLICHT_GESCHAEDIGTE_PERSON } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/haftpflicht-geschaedigte-person/haftpflicht-geschaedigte-person.model';
import { HaftpflichtKfzSchadenComponent } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/haftpflicht-kfz-schaden/haftpflicht-kfz-schaden.component';
import { TYPE_HAFTPFLICHT_KFZ_SCHADEN } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/haftpflicht-kfz-schaden/haftpflicht-kfz-schaden.model';
import { HaftpflichtPersonenschadenComponent } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/haftpflicht-personenschaden/haftpflicht-personenschaden.component';
import { TYPE_HAFTPFLICHT_PERSONENSCHADEN } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/haftpflicht-personenschaden/haftpflicht-personenschaden.model';
import { HaftpflichtSachschadenHandyComponent } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/haftpflicht-sachschaden-handy/haftpflicht-sachschaden-handy.component';
import { TYPE_HAFTPFLICHT_SACHSCHADEN_HANDY } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/haftpflicht-sachschaden-handy/haftpflicht-sachschaden-handy.model';
import { HaftpflichtSachschadenKabelLeitungComponent } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/haftpflicht-sachschaden-kabel-leitung/haftpflicht-sachschaden-kabel-leitung.component';
import { TYPE_HAFTPFLICHT_SACHSCHADEN_KABEL_LEITUNG } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/haftpflicht-sachschaden-kabel-leitung/haftpflicht-sachschaden-kabel-leitung.model';
import { HaftpflichtSachschadenWaldarbeitenComponent } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/haftpflicht-sachschaden-waldarbeiten/haftpflicht-sachschaden-waldarbeiten.component';
import { TYPE_HAFTPFLICHT_SACHSCHADEN_WALDARBEITEN } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/haftpflicht-sachschaden-waldarbeiten/haftpflicht-sachschaden-waldarbeiten.model';
import { HaftpflichtSpritzWaldarbeitenAufstellungComponent } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/haftpflicht-spritz-waldarbeiten-aufstellung/haftpflicht-spritz-waldarbeiten-aufstellung.component';
import { TYPE_HAFTPFLICHT_SPRITZ_WALDARBEITEN_AUFSTELLUNG } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/haftpflicht-spritz-waldarbeiten-aufstellung/haftpflicht-spritz-waldarbeiten-aufstellung.model';
import { HaftpflichtTierschadenComponent } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/haftpflicht-tierschaden/haftpflicht-tierschaden.component';
import { TYPE_HAFTPFLICHT_TIERSCHADEN } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/haftpflicht-tierschaden/haftpflicht-tierschaden.model';
import { GsmInfoComponent } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/info/gsm-info.component';
import { TYPE_INFO } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/info/info.model';
import { InventaraufstellungTableComponent } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/inventaraufstellung-table/inventaraufstellung-table.component';
import { TYPE_INVENTARAUFSTELLUNG_TABLE } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/inventaraufstellung-table/inventaraufstellung-table.model';
import { KontaktAngabeComponent } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/kontakt-angabe/kontakt-angabe.component';
import { TYPE_KONTAKT_ANGABE } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/kontakt-angabe/kontakt-angabe.model';
import { LenkerAuswaehlenComponent } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/lenker-auswaehlen/lenker-auswaehlen.component';
import { TYPE_LENKER_AUSWAEHLEN } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/lenker-auswaehlen/lenker-auswaehlen.model';
import { NachrichtReferentComponent } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/nachricht-referent/nachricht-referent.component';
import { TYPE_NACHRICHT_REFERENT } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/nachricht-referent/nachricht-referent.model';
import { NachrichtenverlaufComponent } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/nachrichtenverlauf/nachrichtenverlauf.component';
import { TYPE_NACHRICHTENVERLAUF } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/nachrichtenverlauf/nachrichtenverlauf.model';
import { SchadenAngabeComponent } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/schaden-angabe/schaden-angabe.component';
import { TYPE_SCHADEN_ANGABE } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/schaden-angabe/schaden-angabe.model';
import { SchadenbeteiligterKontaktErfassenComponent } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/schadenbeteiligter-kontakt-erfassen/schadenbeteiligter-kontakt-erfassen.component';
import { TYPE_SCHADENBETEILIGTER_KONTAKT_ERFASSEN } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/schadenbeteiligter-kontakt-erfassen/schadenbeteiligter-kontakt-erfassen.model';
import { SelectEditComponent } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/select-edit/select-edit.component';
import { TYPE_SELECT_EDIT } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/select-edit/select-edit.model';
import { SelectFilterComponent } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/select-filter/select-filter.component';
import { TYPE_SELECT_FILTER } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/select-filter/select-filter.model';
import { ZahlungsempfaengerComponent } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/zahlungsempfaenger/zahlungsempfaenger.component';
import { TYPE_ZAHLUNGSEMPFAENGER } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/dynamic-form-components/zahlungsempfaenger/zahlungsempfaenger.model';
import { COMPARE_WITH_VISIBLE_MATCHER_PROVIDER } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/matchers/compare-with-visible.matcher';
import { CUSTOM_REQUIRED_MATCHER_PROVIDER } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/matchers/required.matcher';
import { SELECT_VISIBLE_MATCHER_PROVIDER } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/matchers/select-visible.matcher';
import { GSM_VALIDATOR_PROVIDERS, GsmValidators } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/validators';
import { CustomOverlayContainer } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/vendor/custom-overlay-container';
import { GsmErrorInterceptor } from '@app/shared/gsm/gsm-ui-lib-ng-shared/src/lib/gsm-error.interceptor';
import { GsmErrorService } from '@app/shared/gsm/gsm-ui-lib-ng-shared/src/lib/gsm-error.service';
import { GSM_URL_PREFIX } from '@app/shared/gsm/gsm-ui-lib-ng-shared/src/lib/gsm-url-prefix';
import { envConfig } from '@app/shared/loaders/env';
import { IEnv } from '@app/shared/loaders/env.model';
import { CachingInterceptor } from '@app/shared/services/data/caching.interceptor';
import { GSMErrorService } from '@app/shared/services/error/gsm-error.service';
import { DISABLED_MATCHER_PROVIDER, DYNAMIC_FORM_CONTROL_MAP_FN, DYNAMIC_VALIDATORS, DynamicFormControl, DynamicFormControlModel, DynamicFormService, HIDDEN_MATCHER_PROVIDER } from '@ng-dynamic-forms/core';
import { Observable } from 'rxjs';
import { delay, first } from 'rxjs/operators';
import 'moment/locale/de';

const envConfig$: Observable<IEnv> = new Observable(observer => {
  observer.next(envConfig);
  observer.complete();
});

envConfig$.pipe(delay(1), first())
  .subscribe({
    next:  env => bootstrapWithConfig(env),
    error: e => console.error(`The angular bootstrap failed, check the stacktrace for more information: ${e}`)
  });

function bootstrapWithConfig(env: IEnv) {
  if (env.ngProductionMode) {
    enableProdMode();
  }
  bootstrapApplication(AppComponent, applicationConfig)
    .then(() => {
      if ('serviceWorker' in navigator && env.ngProductionMode) {
        navigator.serviceWorker.register('/ngsw-worker.js');
      }
    })
    .catch(err => console.error(err));
}

const applicationConfig: ApplicationConfig = {
  providers: [
    MatDialog,
    DecimalPipe,
    Location,
    {
      provide:  MAT_DATE_FORMATS,
      useValue: DATESTRING_DATE_FORMATS
    },
    {
      provide:  MatPaginatorIntl,
      useClass: MatPaginatorIntlGerman
    },
    [
      {
        provide:  ErrorHandler,
        useClass: GlobalErrorHandler
      }
    ],
    importProvidersFrom(BrowserModule, ServiceWorkerModule.register('/ngsw-worker.js', {
        enabled:              envConfig.ngProductionMode,
        registrationStrategy: 'registerImmediately'
      }),
      MatSidenavModule),
    //GSM
    {
      provide:  GSM_URL_PREFIX,
      useValue: '/api'
    },
    {
      provide:  LOCALE_ID,
      useValue: 'de-DE'
    },
    {
      provide:  MAT_DATE_LOCALE,
      useValue: 'de-DE'
    },
    {
      provide:  DateAdapter,
      useClass: MomentDateAdapter, // needed for GSM
      deps:     [MAT_DATE_LOCALE]
    },
    {
      provide:  MAT_DATE_FORMATS,
      useValue: DATESTRING_DATE_FORMATS
    },
    DISABLED_MATCHER_PROVIDER,
    HIDDEN_MATCHER_PROVIDER,
    CUSTOM_REQUIRED_MATCHER_PROVIDER,
    SELECT_VISIBLE_MATCHER_PROVIDER,
    COMPARE_WITH_VISIBLE_MATCHER_PROVIDER,
    ...GSM_VALIDATOR_PROVIDERS,
    {
      provide:  DYNAMIC_VALIDATORS,
      useValue: new Map(Object.entries(GsmValidators))
    },
    {
      provide:  DynamicFormService,
      useClass: CustomDynamicFormService
    },
    {
      provide:  OverlayContainer,
      useClass: CustomOverlayContainer
    },
    {
      provide:  DYNAMIC_FORM_CONTROL_MAP_FN,
      useValue: (model: DynamicFormControlModel): Type<DynamicFormControl> | null => {
        switch (model.type) {
          case TYPE_CUSTOM_FILE_UPLOAD:
            return CustomFileUploadComponent;
          case TYPE_SCHADEN_ANGABE:
            return SchadenAngabeComponent;
          case TYPE_DOKUMENTEN_ANGABE:
            return DokumentenAngabeComponent;
          case TYPE_CHECKLISTE:
            return ChecklisteComponent;
          case TYPE_ACTION_BUTTON:
            return ActionButtonComponent;
          case TYPE_INFO:
            return GsmInfoComponent;
          case TYPE_ABSCHLUSS:
            return AbschlussComponent;
          case TYPE_SELECT_FILTER:
            return SelectFilterComponent;
          case TYPE_SELECT_EDIT:
            return SelectEditComponent;
          case TYPE_KONTAKT_ANGABE:
            return KontaktAngabeComponent;
          case TYPE_ZAHLUNGSEMPFAENGER:
            return ZahlungsempfaengerComponent;
          case TYPE_COLLISION_PICKER:
            return CollisionPickerComponent;
          case TYPE_GESCHAEDIGTES_FAHRZEUG:
            return GeschaedigtesFahrzeugComponent;
          case TYPE_LENKER_AUSWAEHLEN:
            return LenkerAuswaehlenComponent;
          case TYPE_DATA_ARRAY:
            return DataArrayComponent;
          case TYPE_EIGENLEISTUNG_TABLE:
            return EigenleistungTableComponent;
          case TYPE_GEBAEUDE_SCHADEN:
            return GebaeudeSchadenComponent;
          case TYPE_INVENTARAUFSTELLUNG_TABLE:
            return InventaraufstellungTableComponent;
          case TYPE_DATE_RANGE_PICKER:
            return DateRangePickerComponent;
          case TYPE_SCHADENBETEILIGTER_KONTAKT_ERFASSEN:
            return SchadenbeteiligterKontaktErfassenComponent;
          case TYPE_GESCHAEDIGTE_GERAETE_EINFACH:
            return GeschaedigteGeraeteEinfachComponent;
          case TYPE_GESCHAEDIGTE_GERAETE_KOMPLEX:
            return GeschaedigteGeraeteKomplexComponent;
          case TYPE_FAHRRAD_LISTE:
            return FahrradListeComponent;
          case TYPE_CHIP_CHOICE_MULTIPLE:
            return ChipChoiceMultipleComponent;
          case TYPE_CHIP_CHOICE_AUTOCOMPLETE:
            return ChipChoiceAutocompleteComponent;
          case TYPE_HAFTPFLICHT_PERSONENSCHADEN:
            return HaftpflichtPersonenschadenComponent;
          case TYPE_HAFTPFLICHT_FORDERUNG_AUFSTELLUNG:
            return HaftpflichtForderungAufstellungComponent;
          case TYPE_HAFTPFLICHT_GESCHAEDIGTE_PERSON:
            return HaftpflichtGeschaedigtePersonComponent;
          case TYPE_HAFTPFLICHT_TIERSCHADEN:
            return HaftpflichtTierschadenComponent;
          case TYPE_NACHRICHT_REFERENT:
            return NachrichtReferentComponent;
          case TYPE_NACHRICHTENVERLAUF:
            return NachrichtenverlaufComponent;
          case TYPE_HAFTPFLICHT_KFZ_SCHADEN:
            return HaftpflichtKfzSchadenComponent;
          case TYPE_HAFTPFLICHT_SACHSCHADEN_HANDY:
            return HaftpflichtSachschadenHandyComponent;
          case TYPE_HAFTPFLICHT_SACHSCHADEN_KABEL_LEITUNG:
            return HaftpflichtSachschadenKabelLeitungComponent;
          case TYPE_HAFTPFLICHT_SACHSCHADEN_WALDARBEITEN:
            return HaftpflichtSachschadenWaldarbeitenComponent;
          case TYPE_HAFTPFLICHT_SPRITZ_WALDARBEITEN_AUFSTELLUNG:
            return HaftpflichtSpritzWaldarbeitenAufstellungComponent;
        }
      }
    },
    {
      provide:  GSM_URL_PREFIX,
      useValue: '/api/BXsQ7CY2UWrF'
    },
    {
      provide:  HTTP_INTERCEPTORS,
      useClass: GsmErrorInterceptor,
      multi:    true
    },
    {
      provide:  HTTP_INTERCEPTORS,
      useClass: CommonErrorInterceptor,
      multi:    true
    },
    {
      provide:  HTTP_INTERCEPTORS,
      useClass: CachingInterceptor,
      multi:    true
    },
    {
      provide:  GsmErrorService,
      useClass: GSMErrorService
    },
    provideHttpClient(withInterceptorsFromDi()), // TODO interceptors may be phased out in a later release according to docs
    provideAnimations(),
    provideRouter(MATERIAL_APP_ROUTES, withComponentInputBinding())
  ]
};

